const grantConsent = () => {
  window.gtag('consent', 'update', {
    'ad_storage': 'granted',
    'analytics_storage': 'granted',
    'ad_user_data': 'granted',
    'ad_personalization': 'granted'
  })
}

const denyConsent = () => {
  window.gtag('consent', 'update', {
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied'
  })
}

const cookieConsentConfig = {
  root: '#app',

  guiOptions: {
    consentModal: {
      layout: 'box wide',
      position: 'bottom right',
    },
    preferencesModal: {
      layout: 'box',
    },
  },

  onConsent: ({cookie}) => {
    if (cookie.categories.includes('analytics')) {
      grantConsent()
    } else {
      denyConsent()
    }
  },

  onChange: ({cookie}) => {
    if (cookie.categories.includes('analytics')) {
      grantConsent()
    } else {
      denyConsent()
    }
  },

  categories: {
    necessary: {
      readOnly: true,
      enabled: true,
    },
    analytics: {
      autoClear: {
        cookies: [
          {
            name: /^(_ga|_gid)/,
          },
        ],
      },
    }
  },

  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'Cookie Preferences',
          description: 'Our website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.',
          acceptAllBtn: 'Accept',
          acceptNecessaryBtn: 'Reject',
          showPreferencesBtn: 'Manage preferences',
          closeIconLabel: 'Reject all and close',
        },
        preferencesModal: {
          title: 'Cookie Preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          sections: [
            {
              title: 'Cookie usage',
              description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="/ticket-sales/privacypolicy" class="cc__link">privacy policy</a>.',
            },
            {
              title: 'Strictly necessary cookies',
              description: 'Cookies used for basic website functionality.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Performance and analytics cookies',
              description: 'Tracking cookies used to understand how you interact with the website.',
              linkedCategory: 'analytics'
            }
          ],
        },
      },
    },
  },
}

export default cookieConsentConfig
